import { Link } from "react-router-dom";
import fridgeIcon from "../assets/fridge-icon.svg";
import washingIcon from "../assets/washing-icon.svg";

const BrandServiceLinks = ({ brand }) => {
  const brandLabel = String(brand || "").toUpperCase()
    ? brand.charAt(0).toUpperCase() + brand.slice(1)
    : brand;
  const brandSlug = String(brand || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-");

  const sections = [
    {
      title: `${brandLabel} Washing Machine`,
      icon: washingIcon,
      links: [
        {
          label: `${brandLabel} Washing Machine Service`,
          to: `/${brandSlug}-washing-machine-service-bangalore`,
        },
        {
          label: `${brandLabel} Washing Machine Repair`,
          to: `/${brandSlug}-washing-machine-repair-bangalore`,
        },
        {
          label: `${brandLabel} Washing Machine Not Spinning`,
          to: `/${brandSlug}-washing-machine-not-spinning`,
        },
        {
          label: `${brandLabel} Washing Machine Not Working Repair`,
          to: `/${brandSlug}-washing-machine-not-working-repair`,
        },
        {
          label: `${brandLabel} Washing Machine Water Leak Repair`,
          to: `/${brandSlug}-washing-machine-water-leak-repair`,
        },
        {
          label: `${brandLabel} Washing Machine No Power Issue`,
          to: `/${brandSlug}-washing-machine-no-power-issue`,
        },
        {
          label: `${brandLabel} Washing Machine Noise Problem`,
          to: `/${brandSlug}-washing-machine-noise-problem`,
        },
        {
          label: `${brandLabel} Washing Machine Drum Repair`,
          to: `/${brandSlug}-washing-machine-drum-repair`,
        },
      ],
    },
    {
      title: `${brandLabel} Refrigerator`,
      icon: fridgeIcon,
      links: [
        {
          label: `${brandLabel} Fridge Service`,
          to: `/${brandSlug}-fridge-service-bangalore`,
        },
        {
          label: `${brandLabel} Fridge Not Cooling`,
          to: `/${brandSlug}-fridge-not-cooling`,
        },
        {
          label: `${brandLabel} Fridge Gas Leakage`,
          to: `/${brandSlug}-fridge-gas-leakage`,
        },
        {
          label: `${brandLabel} Fridge Compressor Repair`,
          to: `/${brandSlug}-fridge-compressor-repair`,
        },
        {
          label: `Single Door Fridge`,
          to: "/single-door-fridge-service-bangalore",
        },
        {
          label: `Double Door Refrigerator`,
          to: "/double-door-refrigerator-service-bangalore",
        },
        {
          label: `Side-by-Side Fridge`,
          to: "/side-by-side-fridge-service-bangalore",
        },
        {
          label: `Mini Fridge`,
          to: "/mini-fridge-service-bangalore",
        },
      ],
    },
    {
      title: `Other ${brandLabel} Appliances`,
      links: [
        {
          label: `${brandLabel} Appliance Service Home`,
          to: `/${brandSlug}-appliance-service-bangalore`,
        },
        {
          label: `${brandLabel} AC Service`,
          to: `/${brandSlug}-ac-service-bangalore`,
        },
        {
          label: `Other ${brandLabel} Services`,
          to: `/${brandSlug}-other-services-bangalore`,
        },
      ],
    },
  ];

  return (
    <>
      {sections.map((section) => (
        <div
          className={section.icon ? "card card-grid" : "card"}
          key={section.title}
        >
          {section.icon ? (
            <div className="card-media">
              <img src={section.icon} alt={section.title} />
            </div>
          ) : null}

          <div>
            <h2>{section.title}</h2>
            <div className="links">
              {section.links.map((link) => (
                <Link key={link.label} to={link.to} className="service-link">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BrandServiceLinks;
